import {
  Circle,
  GoogleMap,
  InfoWindow,
  Marker,
  OverlayView,
  useLoadScript,
} from "@react-google-maps/api";
import { useEffect, useMemo, useRef, useState } from "react";

import jobSiteIcon from "../../assets/img/icons/jobsite.svg";
import {
  MapRadiusInfoDiv,
  MapRadiusInfoText,
} from "../FieldServices/JobSites/jobSitesStyles";

const options = {
  streetViewControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
  disableDoubleClickZoom: true,
  gestureHandling: "cooperative",
  mapId: process.env.REACT_APP_JOB_SITES_MAP_ID,
};

const containerStyle = {
  width: "100%",
  height: "85vh",
  borderLeft: "1px solid #e4e7eb",
  borderRadius: "0 10px 10px 0",
};

const mapLibraries = ["places"];
const mapIds = [process.env.REACT_APP_JOB_SITES_MAP_ID];

const DEFAULT_CENTER = {
  lat: 21.424090674479555,
  lng: 39.822141261515604,
};
const circleOptions = {
  strokeColor: "#6F7AFF",
  strokeWeight: 2,
  fillColor: "#6F7AFF",
  fillOpacity: 0.2,
};

const getPixelPositionOffset = (offsetWidth, offsetHeight, labelAnchor) => {
  return {
    x: labelAnchor.x,
    // x: offsetWidth + labelAnchor.x,
    y: offsetHeight + labelAnchor.y,
  };
};

const TaskLocationMap = props => {
  const [showMarkerInfo, setShowMarkerInfo] = useState(false);
  const [userCurrentLocation, setUserCurrentLocation] = useState(null);

  const { isLoaded, loadError } = useLoadScript({
    id: "task-location-map-script-loader",
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_MAPS_JAVASCRIPT_API_KEY ||
      process.env.REACT_APP_GOOGLE_MAPS_KEY,
    libraries: mapLibraries,
    mapIds,
  });

  useEffect(() => {
    fetch("https://hutils.loxal.net/whois")
      .then(resp => resp.json())
      .then(res => {
        if (res && res.ip) {
          const parsedLat =
            typeof res.latitude === "string"
              ? parseFloat(res.latitude)
              : res.latitude;
          const parsedLng =
            typeof res.longitude === "string"
              ? parseFloat(res.longitude)
              : res.longitude;
          if (Number.isFinite(parsedLat) && Number.isFinite(parsedLng)) {
            setUserCurrentLocation({
              lat: parsedLat,
              lng: parsedLng,
            });
          }
        }
      })
      .catch(() => {
        // Whois fetch failed; map will use default center
      });
  }, []);

  const {
    singleAddressMarker,
    setAddressFromMap,
    setMap,
    radius,
    action,
    center,
  } = props;

  const normalizedCenter = useMemo(() => {
    if (!center) return null;
    const rawLat = typeof center.lat === "function" ? center.lat() : center.lat;
    const rawLng = typeof center.lng === "function" ? center.lng() : center.lng;
    const lat = typeof rawLat === "string" ? parseFloat(rawLat) : rawLat;
    const lng = typeof rawLng === "string" ? parseFloat(rawLng) : rawLng;

    if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
    return null;
  }, [center]);

  // Determine the center (priority order): whois/IP (action='add') -> explicit `center` prop -> default
  const mapCenter = useMemo(() => {
    if (action === "add" && userCurrentLocation) return userCurrentLocation;
    if (normalizedCenter) return normalizedCenter;
    return DEFAULT_CENTER;
  }, [normalizedCenter, action, userCurrentLocation]);

  if (loadError) {
    return (
      <div style={{ padding: "20px", color: "#fe5969", textAlign: "center" }}>
        Error loading map. Please check your Google Maps API configuration.
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#5a5f7d" }}>
        Loading map...
      </div>
    );
  }

  return (
    <GoogleMap
      options={options}
      mapContainerStyle={containerStyle}
      center={mapCenter}
      zoom={13}
      onLoad={map => {
        setMap(map);
      }}
      clickableIcons={false}
      onDblClick={location => setAddressFromMap(location)}
    >
      {singleAddressMarker ? (
        <>
          <Marker
            position={singleAddressMarker}
            icon={{
              url: jobSiteIcon,
              scale: 20,
            }}
            draggable
            onDragEnd={e => setAddressFromMap(e)}
          />
          <OverlayView
            key={`ovd`}
            position={singleAddressMarker}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            getPixelPositionOffset={(x, y) =>
              getPixelPositionOffset(x, y, { x: -30, y: -20 })
            }
          >
            <MapRadiusInfoDiv>
              <MapRadiusInfoText>{radius} m</MapRadiusInfoText>
            </MapRadiusInfoDiv>
          </OverlayView>
          <Circle
            center={singleAddressMarker}
            radius={radius}
            options={circleOptions}
          />
        </>
      ) : null}

      {/* {addressMarker && (
        <>
          <Marker
            position={addressMarker}
            icon={{
              url: jobSiteIcon,
              scale: 20,
            }}
            draggable
            onClick={(e) => {
              setShowMarkerInfo(true);
            }}
            onDragStart={() => {
              if (showMarkerInfo) {
                setShowMarkerInfo(false);
              }
            }}
            onDragEnd={(e) => handleSetAddressFromMapClickOrMarkerDrag(e)}
          >
            {showMarkerInfo && (
              <InfoWindow onCloseClick={() => setShowMarkerInfo(false)}>
                <div>test</div>
              </InfoWindow>
            )}
          </Marker>

          <Circle
            center={addressMarker}
            radius={radius}
            options={circleOptions}
          />
        </>
      )} */}
    </GoogleMap>
  );
};

export default TaskLocationMap;
